import { Service } from "./service.model";
import { Entity } from "@entity/domain/models/entity.model";
import { BeneficiarySummary } from "@beneficiary/domain/models/beneficiary-summary.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { IncDocument } from "@core/domain/models/inc-document.model";
import { StatusEnum } from "./status.model";

export class Derivation {
    constructor(
        public readonly id: number,
        public readonly beneficiary: BeneficiarySummary,
        public readonly service: Service,
        public readonly assignedById: number,
        public readonly entityId: number,
        public readonly createdAt: Date,
        public readonly assignedBy?: Entity,
        public readonly entity?: Entity,
        public status?: StatusEnum,
        public readonly reason?: Nullable<string>,
        public documents?: IncDocument[],
        public authorizationFile?: IncDocument,
        public readonly notify_admin_id?: number,
    ) { }
}

export type CreateDerivation = {
    beneficiaryId: number;
    serviceId: number;
    assignedById: number;
    entityId: number;
    status?: string;
    reason?: Nullable<string>;
    documentIds?: number[];
    authorizationFileId?: Nullable<number>;
    notify_admin_id?: number
};

export interface DerivationsWithTotal {
    items: Derivation[];
    total: number;
}